$(document).ready(function () {

  // ------ Header
  if($('.header-wrapper.transparent_header').length > 0){
    var main_header = $('.section-header .header-wrapper.transparent_header');
    var site_logo = $('.header .header_main_logo');
    var logoMaxWidth = site_logo.width(); // Initial site_logo width (desktop)
    var maxMenuShift = 200;
    function updateHeadeLayout(){
      var headerOffsetTop = ($(window).innerHeight() - main_header.innerHeight());
      var scrollTop = $(window).scrollTop();
      if (scrollTop > headerOffsetTop) {
        $('.section-header').addClass('transparent_header-sticky');
      } else {
        $('.section-header').removeClass('transparent_header-sticky');
      }
      
      var progress = scrollTop / headerOffsetTop;
      progress = Math.max(0, Math.min(1, progress));
  
      var minWidth = ($(window).width() < 750)? 132:168;
      var logoWidth = logoMaxWidth - (progress * (logoMaxWidth - minWidth));
      site_logo.css('width', logoWidth + 'px');
  
      var shift = progress * maxMenuShift;
      $('.header .header__inline-menu').css('padding-left', shift + 'px');
  
      if($(window).width() < 990){
        var removepadding = ($(window).width() < 750)? 20:38;
        var centerOffset = ($(window).width() - logoWidth) / 2 - removepadding;
        var marginLeft = progress * centerOffset;
        site_logo.css('margin-left', marginLeft + 'px');
      }
    }
    $('.section-header').addClass('header-loaded');
    $(window).on('scroll', updateHeadeLayout);
    updateHeadeLayout();
  }
  // ------ Header
  
  
  // ------ Main Banner
  if($('.main-banner').length > 0){
    function main_banner_height(){
      $('.main-banner').css('--main-banner-height',($(window).height() + 'px'));
    }
    main_banner_height();
    $(window).on('resize',function(){
      main_banner_height();
    });
    
  }
  // ------ Main Banner


  // ------ Text with icon
  if($('.text-with-icon').length > 0 && $(window).width() < 750){
    var comelete_the_look = new Swiper('.text-with-icon .text-with-icon-row' ,{
      slidesPerView: 'auto',
      spaceBetween: 30,
      mousewheel: {
        forceToAxis: true
      },
      pagination: {
        el: '.text-with-icon .text-with-icon-row .swiper-pagination',
        clickable: true,
      },
    });
  }
  // ------ Text with icon

  // ------ Text with icon
  if($('.featured-collection').length > 0 && $(window).width() < 750){
    var featured_collection = new Swiper('.featured-collection .product-grid' ,{
      slidesPerView: 'auto',
      spaceBetween: 30,
      mousewheel: {
        forceToAxis: true
      },
      pagination: {
        el: '.featured-collection .product-grid .swiper-pagination',
        clickable: true,
      },
    });
  }
  // ------ Text with icon


  // ------  Faq Block
  if($('[data-faq-block]').length > 0){
    $(document).on('click','[data-faq-block] [data-faq-toggle]',function (e) {
      e.preventDefault();
      let curret_block = $(this);
      $(this).next('[data-faq-content]').slideToggle(350).parents('[data-faq-block]').toggleClass('active');
    });
  }
  // ------  Faq Block


  // ------  Main page sidebar
  if($('.main-page-sidebar').length > 0){
    $(document).on('click','#main-page-sidebar-toggle',function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      if($(this).hasClass('active')){
        $(this).next('.main-page-sidebar-links').addClass('open');
      }else{
        $(this).next('.main-page-sidebar-links').removeClass('open');
      }
    });
  }
  // ------  Main page sidebar


  // ------  Store Locator Slider
  if($('.stockist-map-block-slider').length > 0 && $(window).width() < 990 ){
    $('.stockist-map-block').each(function () {
      const $this = $(this);
      const $slider = $this.find('.stockist-map-block-slider')[0];
      const $pagination = $this.find('.swiper-pagination')[0];

      new Swiper($slider, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        pagination: {
          el: $pagination,
          clickable: true,
        }
      });
    });
  }
  // ------  Store Locator Slider


  // ------ Main Product Gallary
  var product_main_thumb_slider = null;
  if ($('#product-thumb-slider').length > 0) {
    product_main_thumb_slider = new Swiper('#product-thumb-slider', {
      slidesPerView: 'auto',
      spaceBetween: 11,
      watchSlidesProgress: true,
    });
  }
  
  if ($('#product-main-slider').length > 0) {
    var mainSliderOptions = {
      slidesPerView: 'auto',
      spaceBetween: 15,
      loop: true,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: '#product-main-slider .swiper-button-next',
        prevEl: '#product-main-slider .swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    };
    if (product_main_thumb_slider) {
      mainSliderOptions.thumbs = {
        swiper: product_main_thumb_slider
      };
    }
    var product_main_sliderr = new Swiper('#product-main-slider', mainSliderOptions);
  }
  // ------ Main Product Gallary


  // ------ Sticky Cart
  if($('#product-sticky-cart').length > 0){
    $(window).on('scroll resize', function () {
      const buttonOffsetTop = $('.product__info-wrapper .product-action-bar .product-form__submit').offset().top;
      if(buttonOffsetTop < $(window).scrollTop()){
        $('#product-sticky-cart').fadeIn();
      }else{
        $('#product-sticky-cart').fadeOut();
      }
    });
    
    $('body').on('click', '.sticky-cart-select-btn', function () {
      $(this).parents('.product-sticky-cart-select').toggleClass('active');
    });
  
    // $('.sticky-cart-select-row input[type="radio"]').on('change', function () {
    //   const selectedLabel = $(this).next('span').text();
    //   $(this).parents('.product-sticky-cart-select').find('.sticky-cart-select-btn span').text(selectedLabel);
    //   $('.product-sticky-cart-select').removeClass('active');
    // });
  
    $(document).on('click', function (e) {
      if (!$(e.target).closest('#product-sticky-cart-select').length) {
        $('.product-sticky-cart-select').removeClass('active');
      }
    });
  }
  // ------ Sticky Cart


  // ------ Map Pin
  if($('.stockist-map').length > 0 && $('.map-pin-img').length > 0){

    $('.stockist-map-block').on('click', function(e){
      e.stopPropagation();
      $(this).addClass('active-store');
      var store_locator = $(this).data('store');
      $('.map-pin').removeClass('active');
      $('.map-pin[data-store-name="'+store_locator+'"]').addClass('active');
    });
    
    $('.map-pin-img').on('click', function(e){
      e.stopPropagation();
      $(this).parents('.map-pin').siblings('.map-pin').removeClass('active');
      $(this).parents('.map-pin').toggleClass('active');
      if($(this).parents('.map-pin').hasClass('active')){
        var store_locator = $(this).parents('.map-pin').data('store-name');
        $('.stockist-map-block[data-store="'+store_locator+'"]').addClass('active-store');
      }else{
        $('.stockist-map-block').removeClass('active-store');
      }
    });
  
    $('.map-info-close').on('click', function(e){
      e.stopPropagation();
      $(this).closest('.map-pin').removeClass('active');
      $('.stockist-map-block').removeClass('active-store');
    });
  
    $(document).on('click', function(e){
      if(!$(e.target).closest('.map-pin').length){
        $('.map-pin').removeClass('active');
        $('.stockist-map-block').removeClass('active-store');
      }
    });
  }
  // ------ Map Pin
});